function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './ApplicantDetails.css';
import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { isEmpty } from 'lodash';
import { TextInput, Select, Phone, Checkbox, RadioButtons } from './components/FormFields';
import ActionsPanel from '../ActionsPanel';
import { getDictionaryItem, get } from '../../../../utils';
import { IconWarning } from '../../../atoms/Icons/';
import { SaveLongTourismEntryPermit } from '../actions';
import { formatDistanceToNowStrict } from 'date-fns';
import { uploadConsent } from '../actions';
const StepRender = props => {
  const {
    context,
    updateContext,
    updateSteps,
    currentStepId,
    stepConfig,
    rtl = false,
    setTranslateValue,
    getTranslateValue,
    generateStepData,
    validateCurrentFields,
    getLookupOptions,
    setApplicationNumber,
    setDocuments,
    appRef,
    apiConfig,
    applicationNumber,
    isTranslateAvaible,
    isLoadingWizard
  } = props;
  const [validate, setValidate] = useState(false);
  const [errorServerMessage, setErrorServerMessage] = useState('');
  const [isRequesting, setIsRequesting] = useState(false);
  const [validForm, setValidForm] = useState(false);
  const isChildrenApp = useMemo(() => {
    if (!context['birthDate'] || !context['birthDate'].value || !context['birthDate'].value.length) return false;
    const parsedDate = new Date(context['birthDate'].value.replaceAll('-', '/'));
    console.log(parsedDate, context['birthDate'].value);
    const getyears = parseFloat(formatDistanceToNowStrict(parsedDate));
    return getyears < 18;
  }, [context]);
  const {
    data: {
      title,
      adPersonalDetailsTitle,
      adContactDetailsTitle,
      adContactDetailsMessage,
      adInfoMessage,
      adMessage,
      policyMessage,
      countriesList,
      buttonBackUrl
    },
    dictionary,
    validateMessage,
    dictionaryNavigation
  } = stepConfig;
  // const [context, setContext] = useState({});
  const history = useHistory();
  const nextStepId = currentStepId + 1;
  const prevStepId = currentStepId - 1;
  const fieldsList = [{
    apiName: '',
    name: 'IAgreeThatProvidedContact',
    type: 'checkbox',
    required: isChildrenApp
  }, {
    apiName: 'isInsideUAE',
    name: 'Applicant',
    type: 'radio',
    required: true
  }, {
    apiName: 'motherNameEN',
    name: 'MotherNameEnglish',
    type: 'text',
    required: true,
    relatedFieldName: 'motherNameAR'
  }, {
    apiName: 'motherNameAR',
    name: 'MotherNameArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'motherNameEN'
  }, {
    apiName: 'maritalStatusId',
    name: 'MaritalStatus',
    type: 'select',
    required: true
  }, {
    apiName: 'religionId',
    name: 'Religion',
    type: 'select',
    required: true
  }, {
    apiName: 'FaithId',
    name: 'Faith',
    type: 'select',
    required: true
  }, {
    apiName: 'educationId',
    name: 'Education',
    type: 'select',
    required: true
  }, {
    apiName: 'professionId',
    name: 'Profession',
    type: 'select',
    required: true
  }, {
    apiName: 'languageId',
    name: 'FirstLanguage',
    type: 'select',
    required: true
  }, {
    apiName: 'arrivalCountryId',
    name: 'ComingFromCountry',
    type: 'select',
    required: true
  }, {
    apiName: 'bankStatementCountryId',
    name: 'BankStatementCountry',
    type: 'select',
    required: true
  }, {
    apiName: 'email',
    name: 'Email',
    type: 'email',
    required: true
  }, {
    apiName: '',
    name: 'ConfirmEmail',
    type: 'email',
    required: true
  },
  // { apiName: 'mobileNo', name: 'MobileNumber', type: 'phone', required: true },
  // { apiName: 'preferredSmsLanguage', name: 'PreferredSMSLanguage', type: 'select', required: true },

  {
    apiName: 'emirateId',
    name: 'Emirate',
    type: 'select',
    required: true
  }, {
    apiName: 'cityId',
    name: 'City',
    type: 'select',
    required: true
  }, {
    apiName: 'areaId',
    name: 'Area',
    type: 'select',
    required: true
  }, {
    apiName: 'street',
    name: 'Street',
    type: 'text',
    required: true
  }, {
    apiName: 'building',
    name: 'BuildingVilla',
    type: 'text',
    required: true
  }, {
    apiName: '',
    name: 'Floor',
    type: 'text'
  }, {
    apiName: '',
    name: 'FlatVillaNumber',
    type: 'text'
  }, {
    apiName: 'landmark',
    name: 'Landmark',
    type: 'text'
  }, {
    apiName: 'makaniNo',
    name: 'MakaniNumber',
    type: 'text'
  }, {
    apiName: 'addressOutsideCountryId',
    name: 'Country',
    type: 'select',
    required: true
  }, {
    apiName: 'addressOutsideCity',
    name: 'City',
    replacedFieldName: 'outsideCity',
    type: 'text',
    required: true
  }, {
    apiName: 'addressOutsideTelNo',
    name: 'MobileNumber',
    replacedFieldName: 'outsideMobileNumber',
    type: 'phone',
    required: true
  }, {
    apiName: 'addressOutside1',
    name: 'Address',
    type: 'text',
    required: true
  }, {
    apiName: 'addressOutside2',
    name: 'Address2',
    type: 'text',
    required: true,
    staticName: 'Address Outside 2 * (static label)'
  }, {
    apiName: 'visitReason',
    name: 'VisitReason',
    type: 'select',
    required: true,
    staticName: 'Visit Reason * (static label)'
  }, {
    apiName: 'visitDuration',
    name: 'VisitDuration',
    type: 'select',
    required: true,
    staticName: 'Visit Duration * (static label)'
  }
  // {
  //   apiName: 'entryType',
  //   name: 'EntryType',
  //   type: 'select',
  //   required: true,
  //   staticName: 'Entry Type * (static label)',
  // },
  ];
  const dashboardUrl = get(buttonBackUrl, 'jss.value.href') || '/';
  const warningMessage = get(adMessage, 'jss');
  const panelButtonState = {
    continue: {
      inactive: !validForm,
      loading: isLoadingWizard || isRequesting,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationContinue')
    },
    back: {
      inactive: false,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationBack')
    },
    save: {
      inactive: !validForm,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSave')
    }
  };
  const submitData = async (isDraft, appId) => {
    setErrorServerMessage('');
    setIsRequesting(true);
    const {
      applicationNumber = '',
      documents = [],
      isSuccess = false,
      error
    } = await SaveLongTourismEntryPermit(apiConfig, context, isDraft, appId);
    console.log('error', error);
    setIsRequesting(false);
    if (!isEmpty(error)) {
      const errorMessage = rtl && error.ar ? error.ar : error.en || '';
      setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
      return false;
    }
    if (isSuccess && applicationNumber.length) {
      setApplicationNumber(applicationNumber);
      setDocuments(documents);
      return true;
    }
    return false;
  };
  const sendParentalConsent = async () => {
    if (!isChildrenApp) return false;
    await uploadConsent({
      apiKey: apiConfig.apiKey,
      sessionId: apiConfig.sessionId
    }, {
      uuids: {
        email: String(context['email'].value || '').toLocaleLowerCase(),
        "Child Full Name": `${context['firstNameEN'] ? context['firstNameEN'].value : ''} ${context['lastNameEN'] ? context['lastNameEN'].value : ''}`
      },
      activity_timestamp: Math.floor(Date.now() / 1000),
      consent_source: 'GDRFA Project',
      custom_parameters: {
        PhoneNumber: `${context['addressOutsideTelNo'].code}${context['addressOutsideTelNo'].value}`,
        City: context['addressOutsideCity'] ? context['addressOutsideCity'].value : '',
        FormURL: window.location.href
      },
      consent_info: [{
        processing_purpose_id: 6,
        processing_purpose_name: "Parental consent",
        consented_items: [{
          consent_purpose_id: 11,
          consent_granted: context['IAgreeThatProvidedContact'].value ? true : false
        }]
      }]
    });
  };
  const panelActions = {
    contionueAction: async () => {
      if (validateCurrentFields && validateCurrentFields(fieldsList)) {
        setValidate(true);
        return;
      }
      await sendParentalConsent();
      const success = await submitData(false, applicationNumber);
      if (success) updateSteps(nextStepId);
    },
    saveAction: async () => {
      if (validateCurrentFields && validateCurrentFields(fieldsList)) {
        setValidate(true);
        return;
      }
      await sendParentalConsent();
      const success = await submitData(false, applicationNumber);
      if (success) history.push(dashboardUrl);
    },
    backAction: () => {
      updateSteps(prevStepId);
    }
  };
  useEffect(() => {
    generateStepData && generateStepData(fieldsList, dictionary);
    appRef && appRef.current.scrollIntoView({
      behavior: 'smooth'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (validateCurrentFields && !validateCurrentFields(fieldsList)) setValidForm(true);else setValidForm(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: " module-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: 'h2',
    field: title || {
      value: ''
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: 'h4  col-md-12',
    field: {
      value: getDictionaryItem(dictionary, 'IsTheApplicantInsideTheUAE') || 'Is the applicant Inside the UAE? *'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "  col-md-12  form-field"
  }, /*#__PURE__*/React.createElement(RadioButtons, _extends({}, context['isInsideUAE'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('insideOutsideCountry') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "  col-md-12  form-field"
  }, warningMessage && /*#__PURE__*/React.createElement("div", {
    className: "field__info-box"
  }, /*#__PURE__*/React.createElement(IconWarning, null), /*#__PURE__*/React.createElement(RichText, {
    field: warningMessage
  })), /*#__PURE__*/React.createElement(RichText, {
    field: get(adInfoMessage, 'jss'),
    className: "field__info"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: 'h3 title col-md-12 ',
    field: {
      value: get(adPersonalDetailsTitle, 'jss.value') || ' '
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['motherNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage
  }, context['motherNameAR'], {
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['maritalStatusId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('listofMaritalStatus') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['religionId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('religions') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['FaithId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    parentDependent: true,
    parentValueId: context['religionId'] && context['religionId'].value,
    options: getLookupOptions && getLookupOptions('faiths') || []
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['educationId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('education') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['professionId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('profession') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['languageId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('language') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['arrivalCountryId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['bankStatementCountryId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['visitReason'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('visitReasons') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['visitDuration'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('visitDuration') || [],
    rtl: rtl
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: 'h3 title col-md-12 ',
    field: {
      value: get(adContactDetailsTitle, 'jss.value') || 'Is the applicant Inside the UAE? *'
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: 'description  col-md-12 ',
    field: {
      value: get(adContactDetailsMessage, 'jss.value') || ' '
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['email'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage
  }, context['ConfirmEmail'], {
    confirmField: context['email'] && context['email'].value,
    rtl: rtl
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: 'h4 sub-title col-md-12 ',
    field: {
      value: getDictionaryItem(dictionary, 'AddressInsideUAE') || 'Address inside UAE'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['emirateId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('emirates') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['cityId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    parentDependent: true,
    parentValueId: context['emirateId'] && context['emirateId'].value,
    options: getLookupOptions && getLookupOptions('cities') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['areaId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    parentDependent: true,
    parentValueId: context['cityId'] && context['cityId'].value,
    options: getLookupOptions && getLookupOptions('areas') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['street'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['building'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['Floor'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['FlatVillaNumber'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['landmark'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['makaniNo'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: 'h4 sub-title col-md-12 ',
    field: {
      value: getDictionaryItem(dictionary, 'AddressOutsideUAE') || 'Address outside UAE'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({
    rtl: rtl
  }, context['addressOutsideCountryId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || []
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['addressOutsideCity'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, context['addressOutsideTelNo'] && /*#__PURE__*/React.createElement(Phone, _extends({}, context['addressOutsideTelNo'], {
    countryValues: countriesList,
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    isDisablePlus: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['addressOutside1'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['addressOutside2'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), isChildrenApp && /*#__PURE__*/React.createElement("div", {
    className: " col-md-12  form-field"
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, context['IAgreeThatProvidedContact'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    required: isChildrenApp
  })))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : ''), /*#__PURE__*/React.createElement("div", {
    className: "module-group-wrap"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: get(policyMessage, 'jss'),
    className: "field__info"
  }))), /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActions,
    buttonState: panelButtonState
  }));
};
const commonStyles = "cjru4lo";
const rtlStyles = "r1hz6bq7";
const ltrStyles = "l182eywu";
export default StepRender;